// types related to appointments (existing)
export const SET_USER_APPOINTMENTS = "SET_USER_APPOINTMENTS";
export const SET_USER_APPOINTMENTS_LOADING = "SET_USER_APPOINTMENTS_LOADING";
export const SET_USER_APPOINTMENTS_LOADED = "SET_USER_APPOINTMENTS_LOADED";
export const RESET_USER_APPOINTMENTS = "RESET_USER_APPOINTMENTS";

// new types for home data (services, staff, dateNowServer)
export const SET_HOME_SERVICES = "SET_HOME_SERVICES";
export const SET_HOME_STAFF = "SET_HOME_STAFF";
export const SET_HOME_DATE_NOW = "SET_HOME_DATE_NOW";
export const SET_HOME_LOADING = "SET_HOME_LOADING";
export const SET_HOME_LOADED = "SET_HOME_LOADED";
export const RESET_HOME = "RESET_HOME";
